import { IItem, OrganizationStatuses } from '../interfaces/organizations';
import { ISravniRating } from '../interfaces/ratings';
import { sortArray } from '../utils/sort';

export const getOrganizationsOptions = (organizationsList: IItem[], rating?: ISravniRating[]) => {
  let topRatingList = [];

  if (rating?.length) {
    topRatingList = rating.map(({ organizationName, organizationId, organizationAlias }) => ({
      label: organizationName,
      value: organizationId,
      alias: organizationAlias,
    }));
  }

  const mainList = organizationsList
    .filter(
      ({ status, id }) =>
        status === OrganizationStatuses.ACTIVE &&
        topRatingList.every(({ value }) => value.toString() !== id.toString()),
    )
    .map(({ name, id, alias }) => ({
      label: name,
      value: id.toString(),
      alias: alias,
    }));

  return [...topRatingList, ...sortArray(mainList, 'label')];
};
